<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className+'__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" :class="className+'__link'" target="_blank"><h2>{{item.title}}</h2></a>
                <router-link v-else :to="item.path" :class="className+'__link'"><h2>{{item.title}}</h2></router-link>
            </li>

            <li v-else :class="className+'__li'" :key="item.title">
                <div v-if="isMobile" :class="className+'__link gnb__link--toggle'"><h2>{{item.title}}</h2></div>
                <router-link v-else :to="item.path" :class="className+'__link gnb__link--toggle'"><h2>{{item.title}}</h2></router-link>
                <ul :class="className+'__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{child.title}}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className : String,
        indexNum : String,
    },
    data: function(){
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs : [
                {
                    title : "PRODUCTS",
                    path : "/en/products/UWSS",
                    children : [
                        {
                            title : "UWSS",
                            path : "/en/products/UWSS",
                        },
                        {
                            title : "WEBCastle",
                            path : "/en/products/WEB",
                        },
                        {
                            title : "WSFinder",
                            path : "/en/products/WS",
                        },
                        {
                            title : "WMDS",
                            path : "/en/products/WMDS",
                        },
                    ]
                },
                {
                    title : "RESOURCES",
                    path : "/en/stories/UWSSRESOURCES",
                    children : [
                        {
                            title : "UWSS Resources",
                            path : "/en/stories/UWSSRESOURCES",
                        },
                        {
                            title : "Customer Stories",
                            path : "/en/stories/COUSTOMER",
                        },
                    ]
                },
                {
                    title : "PARTNERS",
                    path : "/en/partners",
                },
                // {
                //     title : "PRICING",
                //     path : "/en/pricing",
                // },
                // {
                //     title : "SUPPORT",
                //     href : "https://support.f1security.co.kr/",
                // },
                {
                    title : "ABOUT US",
                    path : "/en/aboutus/COMPANY",
                    children : [
                        {
                            title : "Company",
                            path : "/en/aboutus/COMPANY",
                        },
                        {
                            title : "News",
                            path : "/en/aboutus/NEWS",
                        },
                        {
                            title : "Location",
                            path : "/en/aboutus/LOCATION",
                        },
                    ]
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function(){
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted: function(){
    },
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    }
};
</script>